import { AnyType } from "../interfaces";
import createStore from "./create-store";

export default function createDataHook<T>(initialState: T, dataFetcher: (...args: AnyType[]) => Promise<T>) {
  const [useIsFetchingData, setIsFetchingData] = createStore<boolean>(false);
  const [useData, setData] = createStore<T>(initialState);

  async function fetchData(...args: Parameters<typeof dataFetcher>) {
    setIsFetchingData(true);

    const data = await dataFetcher(...args);

    setData(data);
    setIsFetchingData(false);
  }

  return function useDataExported(): [T, boolean, typeof fetchData, typeof setData] {
    const isFetchingData = useIsFetchingData();
    const data = useData();

    return [data, isFetchingData, fetchData, setData];
  }
}
